let state = {
    inited: false,
    on_training: false,
    is_new: true,
    user_state: 0, // 0 未关注，1已关注
    nickname: "", //孩子姓名
    icon: "", // 头像
    birthday: "",
    age: "",
    remind_time: "",
    point: "",
    city: "",
    city_id: "",
    province_id: "",
    province: "",
    uid: "",
    complete: ""
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/habitUserInfo/state.js